import {ButtonPrimary, Col, Row, CheckboxPure, DatePickerPure, InputContainer} from '@modifi/ui'
import PropTypes from 'prop-types'
import React, {useState, useEffect} from 'react'
import moment from 'moment'
import {matchGroups, matchTypes} from '../../constants'
import {useAbility} from '../../../../constants/permissions'
import {TRANSACTION} from '../../../../constants/section'

const earliestDirectDebitDate = () => {
  const today = moment()
  const cutoffTimeOfDate = moment('13:30', 'HH:mm')
  // earliest selectable date...
  // - if today is not saturday or sunday and current time <= 13:30 ==> today + weekday
  if ([0, 5, 6].includes(today.day()) === false && today.isBefore(cutoffTimeOfDate)) {
    return moment().add(1, 'day')
  }
  return moment().add(2, 'day')
}

const DirectDebitReturnForm = ({
  pending,
  sourceEntity,
  targetEntities,
  confirmMatch,
  matchType,
  matchGroup,
  completed,
  closeDialog,
}) => {
  const [skipDirectDebitReschedule, setSkipDirectDebitReschedule] = useState(false)
  const [directDebitExecutionDate, setDirectDebitExecutionDate] = useState(null)
  const ability = useAbility()
  const isAllowed = ability.can('match', TRANSACTION)
  const handleConfirm = e => {
    e.preventDefault()
    confirmMatch({
      matchType,
      matchGroup,
      sourceEntity,
      targetEntities,
      directDebitExecutionDate,
    })
  }

  useEffect(() => {
    if (skipDirectDebitReschedule && directDebitExecutionDate) {
      setDirectDebitExecutionDate(null)
    }
  }, [skipDirectDebitReschedule, directDebitExecutionDate])

  const executionDateSet = !!(directDebitExecutionDate || skipDirectDebitReschedule)

  return (
    <>
      <Row justifyContent="center" mt={40}>
        <Col auto>
          <InputContainer
            inputComponent={DatePickerPure}
            disabled={skipDirectDebitReschedule}
            label="Reschedule direct debit to"
            collapse
            name="directDebitExecutionDate"
            value={directDebitExecutionDate}
            onChange={rescheduleDate => {
              setDirectDebitExecutionDate(rescheduleDate)
            }}
            noWeekends
            fromDate={earliestDirectDebitDate()}
            toDate={moment().add(13, 'days')}
          />
        </Col>
      </Row>
      <Row justifyContent="center">
        <Col auto>
          <CheckboxPure
            value="true"
            checked={skipDirectDebitReschedule}
            onChange={() => setSkipDirectDebitReschedule(!skipDirectDebitReschedule)}
            label="Don't reschedule direct debit."
          />
        </Col>
      </Row>
      <Row justifyContent="center" mt={40}>
        <Col auto>
          <ButtonPrimary
            type="button"
            active={!pending && executionDateSet && isAllowed}
            onClick={!pending && !completed ? handleConfirm : closeDialog}
          >
            {!pending && !completed ? 'Confirm' : 'Close'}
          </ButtonPrimary>
        </Col>
      </Row>
    </>
  )
}

DirectDebitReturnForm.propTypes = {
  sourceEntity: PropTypes.shape({
    amount: PropTypes.string.isRequired,
  }).isRequired,
  pending: PropTypes.bool.isRequired,
  targetEntities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      inputAmount: PropTypes.number,
    })
  ).isRequired,
  matchType: PropTypes.oneOf(matchTypes).isRequired,
  matchGroup: PropTypes.oneOf(matchGroups).isRequired,
  confirmMatch: PropTypes.func.isRequired,
  completed: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
}

export default DirectDebitReturnForm
